<template>
  <el-dialog
    v-loading="loading"
    class="reservedDialog"
    :visible.sync="visible"
    :before-close="handleClose"
    append-to-body
    :width="width"
  >
    <template v-if="!loading && offer">
      <img
        slot="title"
        src="@/assets/images/logo.png"
      />
      <div class="reservedDialog__content">
        <p>
          {{ $t('reserved.dialog.text')}}
        </p>

        <img src="@/assets/images/bonhomme.png" />

        <div class="reservedDialog__radio">
          <ul>
            <li
              v-for="reserved in reserveds"
              :key="reserved"
            >{{reserved}}</li>
          </ul>
        </div>

        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            class="reservedDialog__button"
            :loading="loading"
            @click="handleAccess"
          >{{ $t('reserved.dialog.button')}}</el-button>
        </span>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecordDialog',
  props: {
    offer: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    width: '550px',
    windowWidth: 0,
    loading: false,
    reserveds: []
  }),
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.width = newWidth < 768 ? '100%' : '550px'
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    // init
    this.windowWidth = window.innerWidth

    try {
      this.loading = true

      this.reserveds = [this.offer.booking_restriction.message]

    } catch (error) {
      console.warn(error)
    }

    this.loading = false
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleAccess() {
      this.$emit('access')
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.reservedDialog';

#{$c} {
  img {
    height: 60px;
    width: auto;
  }

  &__content {
    img {
      z-index: 2;
      position: absolute;
      bottom: 0;
      right: 0;
      height: 80%;
      width: auto;
    }
    p {
      padding: 20px;
      font-weight: 700;
    }
  }

  &__radio {
    background-color: #dddddd;
    width: 100%;
    z-index: 1;
  }
  &__radio ul {
    position: relative;
    list-style: none;
    padding: 20px;
    max-width: calc(100% - 175px);
  }
  &__radio li {
    word-break: normal;
  }
  &__radio li:before {
    content: '\2022';
    color: red;
    font-size: 24px;
    padding: 5px;
  }

  &__button {
    margin: 15px;
    text-transform: uppercase;
  }
}
</style>